export function isAudio(filename) {
    if (!filename) {
        return false;
    }
    const audioExtensions = ["mp3", "wav", "ogg"]; // Add more audio extensions if needed
    const extension = filename.split(".").pop().toLowerCase();
    return audioExtensions.includes(extension);
}



export function isVideo(filename) {
    if (!filename) {
        return false; // Si filename no está definido o es null, asumimos que no es un video
    }
    const videoExtensions = ["mp4", "webm", "ogg"]; // Puedes agregar más extensiones de video si lo necesitas
    const extension = filename.split(".").pop().toLowerCase();
    return videoExtensions.includes(extension);
}

export function isImage(filename) {
    if (!filename) {
        return false;
    }
    const imageExtensions = ["jpg", "jpeg", "png"]; // Add more image extensions if needed
    const extension = filename.split(".").pop().toLowerCase();
    return imageExtensions.includes(extension);
}